<template>
	<article :class="$style.root">
		<div role="tablist">
			<button
				v-for="tab in tabs"
				:id="`tabid-${tab}`"
				:key="tab"
				:aria-controls="tab"
				:aria-selected="activeTab === tab ? 'true' : 'false'"
				role="tab"
				type="button"
				@click="loadTab($event, tab)"
			>
				{{ tab }}
			</button>
		</div>
		<component
			:is="component"
			:id="activeTab"
			:key="activeTab"
			role="tabpanel"
			:aria-labelledby="`tabid-${activeTab === 'Preview' ? 'Preview' : 'Code'}`"
		/>
	</article>
</template>

<script>
import Content from '@/components/Content'
import { defineAsyncComponent, ref } from '@vue/composition-api'

const Code = defineAsyncComponent(() =>
	import(
		/* webpackChunkName: "code" */
		/* webpackMode: "lazy" */
		/* webpackPreload: true */
		'@/components/Code'
	)
)

export default {
	name: 'Preview',
	components: {
		Content,
		Code,
	},
	setup() {
		const component = ref('Content')
		const activeTab = ref('Preview')
		const tabs = ['Preview', 'Code']
		const loadTab = (e, tab) => {
			component.value = tab === 'Preview' ? 'Content' : 'Code'
			activeTab.value = e.target.innerText
		}

		return {
			activeTab,
			component,
			loadTab,
			tabs,
		}
	},
}
</script>

<style lang="less" module>
[role='tablist'] {
	-ms-overflow-style: none;
	border: 1px solid #theme.dark[gray4];
	border-width: 1px 0;
	overflow-x: auto;
	scrollbar-width: none;
	white-space: nowrap;

	&::-webkit-scrollbar {
		height: 0;
		width: 0;
	}
}

[role='tab'] {
	background: #theme.dark[gray4];
	border: 0 none;
	color: #theme.dark[text];
	font-family: #theme.typography[base];
	font-size: 1.4rem;
	font-weight: 500;
	outline: 0;
	padding: #theme.spacing[m] #theme.spacing[l];

	&:hover,
	&:focus {
		background: #theme.dark[gray3];
		color: #theme.dark[text];
	}

	+ [role='tab'] {
		margin-left: 1px;
	}
}

[aria-selected='true'] {
	box-shadow: 0 -3px 0 #theme.dark[red] inset;
	pointer-events: none;
}

.root {
	border-left: 1px solid rgb(56, 56, 61);
	contain: content;
	display: grid;
	grid-template-rows: minmax(42px, 42px) 1fr;
}
</style>
